"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc filter
 * @name common.filter:period
 * @function
 *
 * @description
 * Formats a period (ie. years, month, days).
 *
 * @param {Period} The period to filter.
 *
 * @returns {string} Formatted period.
 */
ngModule.filter("period", function () {
  return function periodFilter(period) {
    if (period == null) {
      return "-";
    }
    var formattedAnnee = period.annees === 0 ? "" : period.annees === 1 ? "1 an" : period.annees + " ans";
    var formattedMois = period.mois === 0 ? "" : (formattedAnnee !== "" ? " et " : "") + (period.mois === 1 ? "1 mois" : period.mois + " mois");
    var formattedJours = period.jours === 0 ? "" : (formattedAnnee !== "" || formattedMois !== "" ? " et " : "") + (period.jours === 1 ? "1 jour" : period.jours + " jours");
    var formatted = formattedAnnee + formattedMois + formattedJours;
    return formatted;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/period-filter.js
// module id = 2706
// module chunks = 13